import { Check } from "lucide-react";
import { Reveal } from "../Reveal";
import { SectionHeading } from "./About";
import { DELIVERY } from "../../lib/siteData";

export const DeliveryModel = () => {
  return (
    <section id="delivery" data-testid="delivery-section" className="bg-forest py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            light
            eyebrow="Delivery Model"
            title="One consortium across the full project lifecycle"
            subtitle="From assessment to long-term optimization — coordinated at every stage."
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {DELIVERY.map((phase, i) => (
            <Reveal
              key={phase.title}
              delay={i * 100}
              data-testid={`delivery-stage-${i}`}
              className="rounded-2xl border border-white/10 bg-white/[0.04] p-8 backdrop-blur-sm"
            >
              <div className="flex items-baseline gap-3">
                <span className="font-heading text-4xl font-extrabold text-lime-bright">{phase.stage}</span>
                <h3 className="font-heading text-xl font-bold tracking-tight text-white">{phase.title}</h3>
              </div>
              <div className="mt-6 h-px w-full bg-white/10" />
              <ul className="mt-6 space-y-3.5">
                {phase.items.map((item, j) => (
                  <li key={j} className="flex items-start gap-3">
                    <Check className="mt-1 shrink-0 text-lime-bright" size={15} strokeWidth={3} />
                    <span className="font-body text-sm leading-relaxed text-white/75">{item}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
